function calculateTotalSum(arr) {
    let totalSum = 0;
    let totalStudPcs = 0;
    let totalStudWeight = 0;
    let totalSelfWeight = 0;

    arr.forEach(obj => {
        // Check if the 'total' field exists and is not null or undefined
        if (obj.hasOwnProperty('total') && obj.total !== null && obj.total !== undefined) {
            // Convert 'total' to a number if it's a string
            const totalValue = typeof obj.total === 'string' ? parseFloat(obj.total) : obj.total;

            // Add the numeric value to the total sum
            if (!isNaN(totalValue)) {
                totalSum += totalValue;
            }
        }

        // Check if the 'studd_pieces' field exists and is not null or undefined
        if (obj.hasOwnProperty('studd_pieces') && obj.studd_pieces !== null && obj.studd_pieces !== undefined) {
            const studPcsValue = typeof obj.studd_pieces === 'string' ? parseFloat(obj.studd_pieces) : obj.studd_pieces;

            if (!isNaN(studPcsValue)) {
                totalStudPcs += studPcsValue;
            }
        }

        // Check if the 'studd_weight' field exists and is not null or undefined
        if (obj.hasOwnProperty('studd_weight') && obj.studd_weight !== null && obj.studd_weight !== undefined) {
            const studWeightValue = typeof obj.studd_weight === 'string' ? parseFloat(obj.studd_weight) : obj.studd_weight;

            if (!isNaN(studWeightValue)) {
                totalStudWeight += studWeightValue;
            }
        }

        // Check if the 'self_weight' field exists and is not null or undefined
        if (obj.hasOwnProperty('self_weight') && obj.self_weight !== null && obj.self_weight !== undefined) {
            const selfWeightValue = typeof obj.self_weight === 'string' ? parseFloat(obj.self_weight) : obj.self_weight;

            if (!isNaN(selfWeightValue)) {
                totalSelfWeight += selfWeightValue;
            }
        }
    });

    return {
        totalSum: totalSum.toLocaleString('en-IN'),
        totalStudPcs: totalStudPcs.toLocaleString('en-IN'),
        totalStudWeight: totalStudWeight.toLocaleString('en-IN'),
        totalSelfWeight: totalSelfWeight.toLocaleString('en-IN')
    };
}

function calculateGST(orderType, state, totalValue, diamondPrice, labourCharge, extraCost) {
    const subTotal = parseFloat((parseFloat(diamondPrice) + parseFloat(labourCharge)).toFixed(2));
    let dcgstPercentage = 0;
    let dsgstPercentage = 0;
    let lcgstPercentage = 0;
    let lsgstPercentage = 0;
    let digstPercentage = 0;
    let ligstPercentage = 0;
    let igstPercentage = 0;
    let sgstPercentage = 0;
    let cgstPercentage = 0;

    // Extra cost GST percentages
    let extraCostCGSTPercentage = 0;
    let extraCostSGSTPercentage = 0;
    let extraCostIGSTPercentage = 0;

    let extraCostCGSTValue = 0;
    let extraCostSGSTValue = 0;
    let extraCostIGSTValue = 0;

    if (orderType.toLocaleLowerCase() === 'self') {
        if (state.toLocaleLowerCase() === 'gujarat') {
            dcgstPercentage = 0.75;
            dsgstPercentage = 0.75;
            lcgstPercentage = 2.5;
            lsgstPercentage = 2.5;
        } else {
            digstPercentage = 1.5;
            ligstPercentage = 5;
        }
    } else if (orderType.toLocaleLowerCase() === 'job-work') {
        if (state.toLocaleLowerCase() === 'gujarat') {
            sgstPercentage = 2.5;
            cgstPercentage = 2.5;
        }
        else if (state.toLocaleLowerCase() === 'sez') {
            igstPercentage = 0;
        }
        else {
            igstPercentage = 5;
        }
    }

    // Calculate diamond and labor GST
    const dcgstValue = diamondPrice * (dcgstPercentage / 100);
    const dsgstValue = diamondPrice * (dsgstPercentage / 100);
    const lcgstValue = labourCharge * (lcgstPercentage / 100);
    const lsgstValue = labourCharge * (lsgstPercentage / 100);
    const digstValue = diamondPrice * (digstPercentage / 100);
    const ligstValue = labourCharge * (ligstPercentage / 100);
    const igstValue = subTotal * (igstPercentage / 100);
    const sgstValue = subTotal * (sgstPercentage / 100);
    const cgstValue = subTotal * (cgstPercentage / 100);

    // Handle extra cost GST based on the state
    let extraCostWithGST = 0;

    if (extraCost >= 0) {
        extraCost = parseFloat(extraCost) || 0; // Ensure extraCost is a number

        if (state.toLocaleLowerCase() === 'gujarat') {
            extraCostCGSTPercentage = 9;
            extraCostSGSTPercentage = 9;

            extraCostCGSTValue = extraCost * (extraCostCGSTPercentage / 100);
            extraCostSGSTValue = extraCost * (extraCostSGSTPercentage / 100);
        } else {
            extraCostIGSTPercentage = 18;

            extraCostIGSTValue = extraCost * (extraCostIGSTPercentage / 100);
        }

        // Calculate extraCostWithGST by summing relevant GST values
        extraCostWithGST = extraCost + extraCostCGSTValue + extraCostSGSTValue + extraCostIGSTValue;

        // Add extraCostWithGST to totalValue
        totalValue = parseFloat((parseFloat(totalValue) + parseFloat(extraCostWithGST)).toFixed(2));

    }

    // Calculate total value with GST
    let totalValueWithGST = parseFloat(totalValue.toFixed(2)) + dcgstValue + dsgstValue + lcgstValue + lsgstValue + digstValue + ligstValue + igstValue + sgstValue + cgstValue;

    // Round off logic
    const roundedValue = Math.round(totalValueWithGST);
    const decimalPart = totalValueWithGST - Math.floor(totalValueWithGST);
    const roundedOffValue = decimalPart < 0.5 ? parseFloat((Math.floor(decimalPart * 100) / 100).toFixed(2)) : parseFloat(((1 - decimalPart) * 100 / 100).toFixed(2));


    return {
        dcgstPercentage: dcgstPercentage,
        dsgstPercentage: dsgstPercentage,
        sgstPercentage: sgstPercentage,
        cgstPercentage: cgstPercentage,
        lcgstPercentage: lcgstPercentage,
        lsgstPercentage: lsgstPercentage,
        digstPercentage: digstPercentage,
        ligstPercentage: ligstPercentage,
        igstPercentage: igstPercentage,
        dcgstValue: dcgstValue,
        dsgstValue: dsgstValue,
        lcgstValue: lcgstValue,
        lsgstValue: lsgstValue,
        digstValue: digstValue,
        ligstValue: ligstValue,
        igstValue: igstValue,
        sgstValue: sgstValue,
        cgstValue: cgstValue,

        // Extra cost GST information with value and percentage
        extraCostCGSTPercentage: extraCostCGSTPercentage,
        extraCostSGSTPercentage: extraCostSGSTPercentage,
        extraCostIGSTPercentage: extraCostIGSTPercentage,
        extraCostCGSTValue: extraCostCGSTValue,
        extraCostSGSTValue: extraCostSGSTValue,
        extraCostIGSTValue: extraCostIGSTValue,

        extraCostWithGST: extraCostWithGST,
        totalValueWithGST: roundedValue,
        roundedOffValue: roundedOffValue
    };
}




export { calculateTotalSum, calculateGST };

